import Vue from "vue";
import VuePrintPlugin from "./vue-print-plugin";

Vue.use(VuePrintPlugin);

export default VuePrintPlugin;
